import { Button } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'
import './404.scss'

const PageNotFound = () => {
    return (
        <div className="page page-not-found">
            <div>
                <h1>404</h1>
                <h2>Page not found</h2>
                <Link to="/">
                    <Button variant="contained" className="secondary-btn">
                        Back to homepage
                    </Button>
                </Link>
            </div>
        </div>
    )
}

export default PageNotFound
